// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"panorama-vertical"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4.5 2L19.5 2C19.5 2 18 7 18 12C18 17 19.5 22 19.5 22L4.5 22C4.5 22 6 17 6 12C6 7 4.5 2 4.5 2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.5 2L19.5 2C19.5 2 18 7 18 12C18 17 19.5 22 19.5 22L4.5 22C4.5 22 6 17 6 12C6 7 4.5 2 4.5 2Z","strokeWidth":"props.strokeWidth"}}]}]};

const PanoramaVerticalIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'panorama-vertical',
    ref,
    icon: element,
  },
));

PanoramaVerticalIcon.displayName = 'PanoramaVerticalIcon';

export default PanoramaVerticalIcon;
